const features = [
  {
    id: 1,
    tag: '重磅爆料',
    title: '某顶流艺人税务风波后续：工作室深夜发文承认',
    excerpt: '事件持续发酵，多方消息源交叉验证，税务部门已介入调查。知情人士透露金额远超此前传闻，或将牵涉更多相关方。',
    img: 'https://readdy.ai/api/search-image?query=A%20dramatic%20warm-toned%20editorial%20illustration%20of%20breaking%20news%20scene%20with%20red%20spotlight%20effect%2C%20newspaper%20headline%20aesthetic%2C%20dark%20theater%20curtain%20background%20with%20soft%20golden%20light%2C%20mysterious%20and%20intriguing%20atmosphere%2C%20minimal%20modern%20design%20style&width=800&height=600&seq=carousel-topic-01&orientation=landscape',
    views: '128万',
    comments: '36万',
  },
  {
    id: 2,
    tag: '深度解析',
    title: '热门综艺制作团队大换血，背后资本博弈浮出水面',
    excerpt: '连续三季收视冠军综艺突遭制作方重组，业内爆出多方资本角力内幕，节目未来走向引发观众热议。',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20warm-toned%20illustration%20of%20TV%20production%20behind%20the%20scenes%20with%20camera%20equipment%20silhouettes%2C%20dramatic%20stage%20lighting%20in%20amber%20and%20warm%20gold%20tones%2C%20television%20studio%20atmosphere%2C%20minimal%20and%20modern%20editorial%20style&width=800&height=600&seq=carousel-topic-02&orientation=landscape',
    views: '96万',
    comments: '28万',
  },
  {
    id: 3,
    tag: '实锤跟进',
    title: '年度最劲爆恋情实锤：狗仔蹲守三个月终获铁证',
    excerpt: '知名狗仔团队放出长达三个月的追踪记录，多段视频和照片交叉印证，双方工作室暂未回应。',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20warm-toned%20noir-style%20illustration%20of%20paparazzi%20camera%20lens%20with%20city%20night%20bokeh%20lights%2C%20film%20noir%20romantic%20atmosphere%20in%20warm%20amber%20and%20rose%20tones%2C%20vintage%20photography%20aesthetic%2C%20clean%20modern%20editorial%20style&width=800&height=600&seq=carousel-topic-03&orientation=landscape',
    views: '203万',
    comments: '58万',
  },
  {
    id: 4,
    tag: '独家揭秘',
    title: '直播带货一哥被曝供应链造假，品牌方集体解约',
    excerpt: '多位品牌方同时发布解约声明，内部人士曝光选品流程存在严重问题，涉及金额或达数亿元规模。',
    img: 'https://readdy.ai/api/search-image?query=A%20dramatic%20warm-toned%20business%20illustration%20of%20broken%20contract%20papers%20floating%20against%20warm%20gradient%20background%2C%20corporate%20dispute%20atmosphere%20in%20amber%20and%20burnt%20orange%20tones%2C%20modern%20minimal%20editorial%20design%20with%20clean%20layout&width=800&height=600&seq=carousel-topic-04&orientation=landscape',
    views: '176万',
    comments: '49万',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              焦点专题
            </h2>
            <p className="text-sm text-foreground-500">本周最受关注的四大热点事件深度追踪</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
            {features.map((f) => (
              <article
                key={f.id}
                className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={f.img}
                    alt={f.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                  <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded-md">
                    {f.tag}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug">
                    {f.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                    {f.excerpt}
                  </p>
                  <div className="flex items-center gap-4 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {f.views}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i> {f.comments}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}